import { createPendingComponent, PendingFC } from 'components/patterns/suspense/componentWrappers'
import { PendingProps, RequiredProps } from './types'
import { buildArticleBlocks } from './builder'
import { ArticleCardLayout } from './layout'

export const ArticleCard: PendingFC<PendingProps, RequiredProps> = props => (
	<ArticleCardLayout {...buildArticleBlocks(props)} />
)
export const SuspensefulArticleCard = createPendingComponent(ArticleCard)
